const contentBlocks = [
  {
    identifier: 'custom_content',
    label: 'Texto del correo',
    description: 'Texto libre y editable para el mensaje principal del email. Admite variables dinámicas.',
  },
  {
    identifier: 'divider',
    label: 'Separador',
    description: 'Línea divisoria para separar visualmente las secciones del email.',
  },
  {
    identifier: 'custom_steps',
    label: 'Instrucciones de devolución',
    description: 'Muestra los pasos de devolución configurados en el portal, en formato de lista numerada.',
  },
  {
    identifier: 'transaction_details',
    label: 'Resumen de la solicitud',
    description: 'Número de pedido y tipo de resolución (reembolso, cambio...), con enlace al panel del cliente.',
  },
  {
    identifier: 'products_returned',
    label: 'Productos - A devolver',
    description: 'Artículos que el cliente devuelve: imagen, nombre, SKU, variante, importe y motivo.',
  },
  {
    identifier: 'products_requested',
    label: 'Productos - Solicitados',
    description: 'Artículos que el cliente ha solicitado como cambio o nuevo pedido.',
  },
  {
    identifier: 'products_rejected',
    label: 'Productos - Rechazados',
    description: 'Artículos que no han sido aceptados en la devolución, junto al motivo de rechazo.',
  },
  {
    identifier: 'products_accepted',
    label: 'Productos - Aceptados',
    description: 'Artículos aprobados en la revisión de la devolución.',
  },
  {
    identifier: 'products_shipped',
    label: 'Productos - Incluidos en el envío',
    description: 'Artículos que se incluyen en el envío de salida al cliente.',
  },
  {
    identifier: 'summary',
    label: 'Desglose',
    description: 'Tabla con el desglose económico de la operación: importes, ajustes y total.',
  },
  {
    identifier: 'footer_customer_dashboard',
    label: 'Acceso al panel de cliente',
    description: 'Botón o enlace directo para que el cliente acceda a su panel de devoluciones.',
  },
  {
    identifier: 'discount_code',
    label: 'Detalles del código de descuento',
    description: 'Código de descuento o store credit generado, con el aviso legal correspondiente.',
  },
  {
    identifier: 'shipment_status',
    label: 'Widget de estado de envío',
    description: 'Línea de tiempo visual con el estado actual del envío (preparado, enviado, en reparto, entregado).',
  },
  {
    identifier: 'promo_banner',
    label: 'Banner de promoción',
    description: 'Imagen promocional al pie del email con enlace. Solo aparece si hay una imagen configurada.',
  },
]

export const blockLabels = Object.fromEntries(contentBlocks.map(({ identifier, label }) => [identifier, label]))

export const blockDescriptions = Object.fromEntries(
  contentBlocks.map(({ identifier, description }) => [identifier, description])
)

export const defaultBlocks = contentBlocks.map(({ identifier }, position) => ({ identifier, enabled: true, position }))
